import { BillingContractWithServiceContracts } from '@boltenergy-be/shared'
import { Icon, Tooltip, TooltipProps } from '@boltenergy-be/design-system'
import styles from './AddressEanTooltip.module.scss'
import { useTranslation } from 'react-i18next'

const AddressEanTooltip = ({
  serviceContracts,
  placement
}: Pick<BillingContractWithServiceContracts, 'serviceContracts'> & Pick<TooltipProps, 'placement'>) => {
  // i18n
  const { t } = useTranslation()

  return (
    <Tooltip
      {...{ placement }}
      asChild
      tooltipContent={
        <dl className={styles['ean-list']}>
          <div className={styles.entry}>
            <dt>
              <Icon name="electricity" title={t(($) => $.electricity)} size={16} /> <strong>EAN:</strong>
            </dt>
            <dd>{serviceContracts.electricity.deliveryPoint.ean}</dd>
          </div>

          {serviceContracts.gas && (
            <div className={styles.entry}>
              <dt>
                <Icon name="gas" title={t(($) => $.gas)} size={16} /> <strong>EAN:</strong>
              </dt>
              <dd>{serviceContracts.gas.deliveryPoint.ean}</dd>
            </div>
          )}
        </dl>
      }
    >
      <Icon name="info" size={16} className={styles.info} />
    </Tooltip>
  )
}

export default AddressEanTooltip
